import type { ReactNode } from 'react'

import { useMediaQuery, useTheme } from '@material-ui/core'
import { Header, Navigation } from '@monthio/design-system'

import type { HeaderStepData } from '../moduleUtils'

import { KebabMenu } from '../KebabMenu'
import { FLOW_COMPLETED_STEP_INDEX } from '../moduleUtils'

export interface SmartCheckHeaderProps {
	clientLogoSrc: string
	clientId?: number
	activeStep: number
	steps: HeaderStepData[]
	languagesSelectComponent: ReactNode
}

export const SmartCheckHeader = ({
	languagesSelectComponent,
	clientLogoSrc,
	clientId,
	steps,
	activeStep,
}: SmartCheckHeaderProps) => {
	const theme = useTheme()
	const isSmall = useMediaQuery(theme.breakpoints.down('sm'))
	const isFlowCompleted = activeStep === FLOW_COMPLETED_STEP_INDEX
	const clientLogoWidth = isSmall ? '70px' : '132px'

	// If active step is undefined, do not show header
	const step = steps[activeStep]

	const completedPercentage =
		isFlowCompleted || steps.length === 0
			? 100
			: (activeStep / steps.length) * 100

	const headerProps =
		isFlowCompleted || step !== undefined
			? {
					// TRANSLATE:
					progressLabel: `Flow progress ${activeStep + 1} out of ${steps.length}`,
					progress: completedPercentage,
				}
			: {}

	return (
		<Header
			{...headerProps}
			clientLogo={
				clientLogoSrc ? (
					<img width={clientLogoWidth} height={'auto'} src={clientLogoSrc} />
				) : null
			}
		>
			<Navigation>
				{languagesSelectComponent}
				<KebabMenu clientId={clientId} />
			</Navigation>
		</Header>
	)
}
